"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH = exports.TOKENS = exports.HEIGHT = void 0;
var TOKENS = {
  STARS: {
    COLOR: 'yellow',
    MAX_RATE: 5,
    STAR_SIZE: 'normal',
    TYPE: 'full'
  },
  RATING: {
    COLOR: 'secondaryDark'
  }
};
exports.TOKENS = TOKENS;
var WIDTH = '100%';
exports.WIDTH = WIDTH;
var HEIGHT = '100%';
exports.HEIGHT = HEIGHT;